<script>
import { mapState } from 'vuex';
import Lock from '@/assets/icons/lock.svg';

export default {
  name: 'LockIcon',

  components: {
    Lock,
  },

  props: {
    isPremium: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState('user', ['isMember']),
  },
};
</script>

<template>
  <Lock v-if="!isMember && isPremium" style="height:0.8rem" class="ml-1" />
</template>

<style lang="scss" scoped></style>
